import { Context } from 'common/contexts'
import { GlobalStyles } from 'common/styles'
import { AllRoutes } from 'modules/routes/routes'
import { useEffect } from 'react'
import { useTranslation, withTranslation } from 'react-i18next'
import { HashRouter } from 'react-router-dom'
import { Toaster } from 'sonner'

export const App = () => {
  const { t } = useTranslation()
  const lang = localStorage.getItem('Localization') ?? 'uk'
  useEffect(() => {
    document.title = t('title-head')
  }, [lang])

  return (
    <HashRouter>
      <Context>
        <GlobalStyles />
        <Toaster duration={4000} position="top-center" />
        <AllRoutes />
      </Context>
    </HashRouter>
  )
}

export default withTranslation()(App)
